import { RootActionTypes } from '../../../stores/types';
import ActionType from '../constants/ActionType';

export default function hideExclusionRuleDeleteConfirmation(): RootActionTypes {
  return {
    type: ActionType.HideExclusionRuleDeleteConfirmation,
  };
}
